const removeLanguageRegion = (language) => language.toLowerCase().split(/[_-]+/)[0];
export default removeLanguageRegion;
